module.exports = __webpack_public_path__ + "static/media/yoda.7402ed24.jpg";